import { ClientRegistrationState } from '@common/model/client/registration';
import { FormFieldProps } from '@cp/ds/src/components/form/components/field/model';
import { StepName } from './stepNames';

export type FieldName = keyof ClientRegistrationState;
export type FieldList = Readonly<FieldName[]>;
export type FieldConfig = {
  name: FieldName;
  label?: string;
  placeholder?: string;
  controlType?: FormFieldProps<string>['type'];
  required?: boolean;
};

export type RegistrationStep = {
  name: StepName;
  title?: string;
  fields: FieldConfig[];
};

export type FieldToStepMap = Map<FieldName, StepName>;

export interface IRegistrationStepFactory {
  createStep(name: StepName, fields: FieldList): RegistrationStep | null;
  getStepNames(fields: FieldList): StepName[];
}

export const getRemainingSteps = (
  remainingFields: FieldList,
  mapper: FieldToStepMap,
  sorter: (a: StepName, b: StepName) => number,
): StepName[] => {
  const steps: StepName[] = [];
  let step: StepName | undefined = undefined;
  for (const fieldName of remainingFields) {
    step = mapper.get(fieldName);
    if (!step || steps.includes(step)) {
      continue;
    }
    steps.push(step);
  }
  return steps.sort(sorter);
};
